import { useEffect, useRef } from "react";

type Props = {
  title: string;
  rawMarkdown: string;
  open: boolean;
  onClose: () => void;
};

export function SpeakerNoteRawModal({ title, rawMarkdown, open, onClose }: Props) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  if (!open) return null;

  return (
    <dialog
      ref={dialogRef}
      className="surf-note-raw-dialog"
      aria-labelledby="surf-note-raw-title"
      onClose={onClose}
      onCancel={onClose}
    >
      <header className="surf-note-raw-dialog-header">
        <h2 id="surf-note-raw-title">RAW — {title}</h2>
        <button type="button" className="surf-note-raw-dialog-close" onClick={onClose} aria-label="Chiudi">
          ✕
        </button>
      </header>
      <pre className="surf-note-raw-dialog-body">{rawMarkdown}</pre>
      <footer className="surf-note-raw-dialog-footer">
        <button type="button" className="surf-btn surf-btn--ghost" onClick={onClose}>
          Chiudi
        </button>
      </footer>
    </dialog>
  );
}
